import axios from "axios";

// Usa sempre il dominio corrente (funziona con domini custom es. nureal-operation.it);
// fallback alla env var solo se non c'è un origin http valido (es. build/SSR).
const BACKEND_URL =
  typeof window !== "undefined" && window.location.origin.startsWith("http")
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach access token from localStorage too (fallback auth)
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("access_token");
  if (token && !cfg.headers.Authorization) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Errore";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e?.msg ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e))).join(" ");
  return String(d);
}

export function statoBadgeClass(s) {
  return `badge badge-${(s || "bozza").toLowerCase()}`;
}

export function statoLabel(s) {
  const map = {
    bozza: "Bozza",
    in_lavorazione: "In lavorazione",
    in_corso: "In corso",
    completato: "Completato",
    sospeso: "Sospeso",
    annullato: "Annullato",
    attiva: "Attiva",
  };
  return map[s] || s || "-";
}
